export class RecognitionResponse {
    success: boolean;
    title: string;
    message: string;
    errorMessages: string;
}